export function sendGtagPageView(): void {
  if (typeof window.gtag !== 'function') {
    return;
  }

  const pagePath = window.location.pathname + window.location.search + window.location.hash;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pagePath,
  });
}
